import {useEffect, useLayoutEffect, useRef, useState} from "react";
import styles from './Styles.module.scss';

import spriteSheet from '../assets/textures/Preload.jpg';

const FRAME_WIDTH = 1280;
const FRAME_HEIGHT = 720;
const FRAME_COUNT = 20;
const FPS = 20;

const playerStyle = (frameIndex, windowSize) => {
    // 1. Рассчитываем пропорции
    const frameAspectRatio = FRAME_WIDTH / FRAME_HEIGHT;
    const windowAspectRatio = windowSize.width / windowSize.height;

    let scale;
    // 2. Определяем масштаб
    if (windowAspectRatio > frameAspectRatio) {
        // Окно "шире", чем кадр. Масштабируем по ширине.
        scale = windowSize.width / FRAME_WIDTH;
    } else {
        // Окно "уже" (или такое же), чем кадр. Масштабируем по высоте.
        scale = windowSize.height / FRAME_HEIGHT;
    }

    // 3. Рассчитываем размеры отмасштабированного спрайт-листа
    const scaledWidth = FRAME_WIDTH * scale;
    const scaledHeight = FRAME_HEIGHT * scale;

    // 4. Рассчитываем смещение для центрирования
    const offsetX = (windowSize.width - scaledWidth) / 2;
    const offsetY = (windowSize.height - scaledHeight) / 2;

    return {
        width: `${FRAME_WIDTH}px`,
        height: `${FRAME_HEIGHT}px`,
        backgroundImage: `url(${spriteSheet})`,
        backgroundSize: `${FRAME_COUNT * 100}% 100%`,
        backgroundPosition: `${(frameIndex / (FRAME_COUNT - 1)) * 100}% 0`,
        // 5. Применяем трансформации
        position: 'absolute',
        top: `${offsetY}px`,
        left: `${offsetX}px`,
        transform: `scale(${scale})`,
        transformOrigin: 'top left',
        zIndex: 20000000
    };
};

function useWindowSize() {
    const [size, setSize] = useState({ width: 0, height: 0 });
    useLayoutEffect(() => {
        function updateSize() {
            setSize({ width: window.innerWidth, height: window.innerHeight });
        }
        window.addEventListener('resize', updateSize);
        updateSize();
        return () => window.removeEventListener('resize', updateSize);
    }, []);
    return size;
}

function IntroOverlay({ onFinished }) {
    const windowSize = useWindowSize();
    const [currentFrame, setCurrentFrame] = useState(0);

    const [visible, setVisible] = useState(true);
    const [isStarted, setIsStarted] = useState(false);
    const requestRef = useRef();


    useEffect(() => {
        if (isStarted) {
            let startTime = null;
            const frameDuration = 1000 / FPS;

            const animate = (timestamp) => {
                if (!startTime) startTime = timestamp;
                const elapsedTime = timestamp - startTime;
                const newFrame = Math.min(Math.floor(elapsedTime / frameDuration), FRAME_COUNT - 1);

                setCurrentFrame(newFrame);

                if (newFrame > FRAME_COUNT * 0.8 && visible) {
                    setVisible(false);
                }

                if (newFrame < FRAME_COUNT - 1) {
                    requestRef.current = requestAnimationFrame(animate);
                } else {
                    onFinished();
                }
            };

            requestRef.current = requestAnimationFrame(animate);

            return () => cancelAnimationFrame(requestRef.current);
        }
    }, [isStarted]);

    const playVideo = () => {
        setIsStarted(true);
    }

    return (
        <div style={{zIndex: 20000000}}>
            {!isStarted && <div className={styles.welcomeBlock}>
                <h1>Добро пожаловать в Барселону</h1>
                <button onClick={playVideo}>Начать путешествие</button>
            </div>}
            <div className={styles.overlayImage} style={{opacity: visible ? 1 : 0}}>
                <div style={playerStyle(currentFrame, windowSize)}/>
            </div>
        </div>
    );
}

export default IntroOverlay;